export const functionOption = [
  { value: 'CUSTOMER', label: 'Customer' },
  { value: 'REFERRER', label: 'Referrer' },
  { value: 'RESELLER', label: 'Reseller' },
  { value: 'AGENCY', label: 'Agency' },
  { value: 'DISTRIBUTOR', label: 'Distributor' },
  { value: 'EVENT_PROVIDER', label: 'Event provider' },
]
export const regionOption = [
  { label: 'Global', value: '1' },
  { label: 'EU', value: '2' },
  { label: 'EMEA', value: '3' },
  { label: 'MEA', value: '4' },
  { label: 'MENA', value: '5' },
  { label: 'US', value: '6' },
  { label: 'North America', value: '7' },
  { label: 'APAC', value: '8' },
  { label: 'North Asia', value: '9' },
  { label: 'Greater China', value: '10' },
  { label: 'ANZ', value: '11' },
  { label: 'SEA', value: '12' },
  { label: 'ASEAN', value: '13' },
  { label: 'APJ', value: '14' },
]
export const blackListedCountry = ['Iran', 'Cuba', 'North Korea', 'Venezuela', 'Ukraine', 'Syria']
export const topListedCountry = [
  'New Zealand',
  'Australia',
  'United Kingdom',
  'Singapore',
  'United States',
  'Japan',
  'Hong Kong',
  'China',
  'Germany',
  'India',
]
export const BrandCoolnessLabels = {
  VERY_UNCOOL: 'Old School',
  UNCOOL: 'Bit Old School',
  OK: 'OK',
  COOL: 'Pretty Cool',
  VERY_COOL: 'Cool as!',
}
export const BrandHappinessLabels = {
  LOVE__RECOMMEND_US: 'Love recommend us',
  LIKE_US_LOTS: 'Like us lots',
  PRETTY_HAPPY: 'Pretty happy',
  LET_DOWN_A_BIT: 'Let down a bit',
  LET_DOWN_BIG_TIME: 'Let down big time',
  NOT_INTERESTED: 'Not interested',
  SEE_YOU_LATERS: 'See you Laters',
}
export const BrandDepartmentLabels = {
  SALES: 'Sales',
  PRODUCT: 'Product',
  HR: 'HR & Recruitment',
  MARKETING: 'Marketing',
  FINANCE: 'Finance',
  DIGITAL: 'Digital',
  INTERNAL_COMMS: 'Internal Comms',
}
export const BrandSizeLabels = {
  tiny: 'Tiny',
  small: 'Small',
  small_but_growing_fast: 'Small but growing fast',
  medium_national: 'Medium National',
  large_national: 'Large National',
  multi_national: 'Multi-National',
  medium_global: 'Medium Global',
  large_global: 'Large Global',
  fortune_500: 'Fortune 500',
  biggest_brands_on_planet: 'Biggest Brands on Planet',
}
export const BrandHistoryLabels = {
  one_older_vid: 'Just 1 Older Vid',
  few_older_vids: 'A few Old Vids',
  one_ok_vid: 'One OK Vid',
  one_great_vid: 'One Great Vid',
  few_great_vids: 'Heaps of Good Videos',
}



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardSettings/config.ts